module.exports = __webpack_public_path__ + "static/img/not-record.2764d11e.png";